module.exports = __webpack_public_path__ + "frontend/images/gold/carousel/globe@2.png?5e6c71db7e13b351fd5e06a335de2b76";